import request from '@/utils/request'
// REQ-2026-601171 子账号核查数据看板（子账号回访）
// 接口路径与参数名严格按任务书 §2.1，与后端并行开发，联调前调不通是预期
const apiPath = '/cust/childFollowup'
const childFollowupApi = {
  /**
   * 分页查询【子账号回访】列表，返回体含 6 个汇总指标
   */
  fetchList(query) {
    return request.get(`${apiPath}/list`, { params: query })
  },
  /**
   * 查看【子账号回访】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/show/${id}`)
  },
  /**
   * 保存草稿（回访填写 / 市场核实填写共用同一接口，前端只在自己模块内调用）
   */
  saveDraft(data) {
    return request.post(`${apiPath}/draft`, data)
  },
  /**
   * 提交（未接通 / 正常 / 异常 三种提交，由 data 内字段区分）
   */
  submit(data) {
    return request.post(`${apiPath}/submit`, data)
  },
  /**
   * 批量查这些后台账号在 App 里的身份（BUG-2026-742350）。
   * ⚠️ 判据由后端给：它调的就是发通知时决定"发不发得出去"的那条查询。
   *    前端**不要**自己去查 customer / technician_info 再判一遍，两边分叉的话
   *    页面会显示"能收到"而实际收不到，比没有提示更难查。
   */
  fetchReceiverIdentities(userIds) {
    // 15 秒超时是**这一条专用**的：身份只是辅助显示，等全局那个 500000（8 分多钟）毫无意义，
    // 而且它一旦不 settle 就会把调用方的 finally 一起拖住（BUG-2026-268341）。
    // ⚠️ 不要改 utils/request.js 里的全局值 —— 那个是给某些慢接口兜底的，要调得先盘谁在靠它。
    return request.get(`${apiPath}/receiverIdentities`, { params: { userIds }, timeout: 15000 })
  },
  /**
   * 流转记录（时间线）
   */
  fetchActivities(id) {
    return request.get(`${apiPath}/activities/${id}`)
  },
  /**
   * 关闭记录
   */
  fetchCloseRecord(id) {
    return request.get(`${apiPath}/closeRecord/${id}`)
  },
  /**
   * 导出（异步任务，走 sys_task 套路，创建后到「导出记录」下载）
   */
  exportExcel(data) {
    return request.post(`${apiPath}/export`, data)
  },
  /**
   * 市场核实接收人配置：{ userIds: [], roleCodes: [] }。接收人 = 两者的并集
   */
  fetchMarketReceivers() {
    return request.get(`${apiPath}/marketReceivers`)
  },
  saveMarketReceivers(data) {
    return request.post(`${apiPath}/marketReceivers`, data)
  },
  /**
   * 客户完整手机号查看（需按钮权限 finance:subaccountFollowup:viewPhone，命中写审计日志）
   */
  fetchPhone(customerId, followupId) {
    // followupId 可选：后端用它把「在哪条回访任务上看的」写进查看明文手机号的审计日志
    return request.get(`${apiPath}/phone/${customerId}`, { params: followupId ? { followupId } : {} })
  }
}
export default childFollowupApi
